import React from 'react';
import { useDraggable } from '@dnd-kit/core';
import { GripVertical } from 'lucide-react';

const KanbanCard = ({
  id,
  type,
  data,
  draggable = false,
  children,
  onClick,
  isSelected = false,
  style: customStyle = {}
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    isDragging
  } = useDraggable({
    id: `${type}-${id}`,
    data: {
      ...data,
      type,  // Doit venir APRÈS ...data pour ne pas être écrasé par data.type
      id
    },
    disabled: !draggable
  });

  const cardStyle = {
    backgroundColor: isSelected ? '#fef3c7' : 'white',
    borderRadius: '0.5rem',
    border: isSelected ? '2px solid #f59e0b' : '1px solid #e5e0d5',
    padding: '0.75rem',
    cursor: onClick ? 'pointer' : (draggable ? 'grab' : 'default'),
    transition: isDragging ? 'none' : 'all 0.2s ease',
    opacity: isDragging ? 0.4 : 1,
    // Ne pas appliquer de transform - DragOverlay gère l'affichage du drag
    boxShadow: isSelected ? '0 0 0 2px rgba(245, 158, 11, 0.2)' : 'none',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '0.5rem',
    ...customStyle
  };

  const dragHandleStyle = {
    color: '#94a3b8',
    cursor: 'grab',
    flexShrink: 0,
    padding: '0.25rem',
    borderRadius: '0.25rem',
    transition: 'background-color 0.2s',
    display: draggable ? 'flex' : 'none'
  };

  const contentStyle = {
    flex: 1,
    minWidth: 0 // Pour permettre le text-overflow
  };

  const handleCardClick = (e) => {
    // Ne pas déclencher le clic si on drag
    if (isDragging) return;
    if (onClick) onClick(e);
  };

  return (
    <div
      ref={setNodeRef}
      style={cardStyle}
      onClick={handleCardClick}
      onMouseEnter={(e) => {
        if (!isDragging) {
          e.currentTarget.style.borderColor = '#cbd5e1';
          e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.05)';
        }
      }}
      onMouseLeave={(e) => {
        if (!isDragging) {
          e.currentTarget.style.borderColor = '#e5e0d5';
          e.currentTarget.style.boxShadow = 'none';
        }
      }}
    >
      {draggable && (
        <div
          {...attributes}
          {...listeners}
          style={dragHandleStyle}
          onMouseEnter={(e) => {
            e.currentTarget.style.backgroundColor = '#f3efe7';
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.backgroundColor = 'transparent';
          }}
        >
          <GripVertical size={16} />
        </div>
      )}
      <div style={contentStyle}>
        {children}
      </div>
    </div>
  );
};

export default KanbanCard;
